import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import { ECRBActions } from './actions';
import { ICRBStore } from './@types';

const crbSelectors = {
    _getStore(store: IStore) {
        return store.app.crb;
    },
    getHistoryList(store: ICRBStore) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: ICRBStore) {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
    jobToLoadHistory(store: ICRBStore) {
        return jobSelectors.getJobStatus(store, ECRBActions.HISTORY_LOAD);
    },
};
export default crbSelectors;
